var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4312 13.2909C12.6059 13.2909 13.562 14.1958 13.562 15.3081V18.1688C13.562 18.4078 13.7629 18.5994 14.0205 18.605H15.88C17.3454 18.605 18.5366 17.4834 18.5366 16.1051V7.99177C18.5298 7.51747 18.2927 7.07106 17.8859 6.77439L11.4537 1.88442C10.5902 1.23249 9.38244 1.23249 8.5161 1.88628L2.1278 6.77253C1.70537 7.0785 1.46829 7.52491 1.46341 8.00758V16.1051C1.46341 17.4834 2.65463 18.605 4.12 18.605H5.99707C6.26146 18.605 6.4761 18.405 6.4761 18.1595C6.4761 18.1056 6.48293 18.0516 6.49463 18.0005V15.3081C6.49463 14.2023 7.44488 13.2984 8.61073 13.2909H11.4312ZM15.88 20H14.0029C12.9278 19.9758 12.0985 19.1714 12.0985 18.1688V15.3081C12.0985 14.965 11.799 14.6859 11.4312 14.6859H8.61561C8.25561 14.6878 7.95805 14.9677 7.95805 15.3081V18.1595C7.95805 18.2293 7.94829 18.2962 7.92781 18.3595C7.82244 19.2802 6.99707 20 5.99707 20H4.12C1.8478 20 0 18.2525 0 16.1051V8.00107C0.0097561 7.07664 0.456585 6.23034 1.22829 5.67327L7.6039 0.795387C9.0078 -0.264819 10.9639 -0.264819 12.3649 0.793527L18.7863 5.67606C19.5405 6.22383 19.9873 7.06827 20 7.98154V16.1051C20 18.2525 18.1522 20 15.88 20Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon-главная.725c46fd8dce6873bbe9dacef994cf08.svg";
export { ForwardRef as ReactComponent };